import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ApiService } from '../services/api.service';
import { UtilitiesService } from '../services/utilities.service';
import Swal from 'sweetalert2'
import { CommonService } from '../services/common.service';

@Component({
    selector: 'app-users',
    templateUrl: './users.component.html',
    styleUrls: ['./users.component.css'],
    standalone: false
})
export class UsersComponent implements OnInit {

  page = 1;
  pageSize = 10;

  list_length = 0;
  roles: any[] = [];
  users: any[] = [];
  token: any;

  new_user = {
    email: '',
    password: '',
    username: '',
    phone: 0,
    role_id: 2
  }

  user_password = {
    id: null,
    email: '',
    password: '',
  }

  user = {
    email: '',
    password: '',
    username: '',
    phone: 0,
    role_id: 2
  }

  employee = {
    name: null,
    email: null,
    phone: null,
    address: null,
    country: null,
    account_number: null,
    bank_name: null,
    id_number: null,
    id_expiry_date: null,
    id_attachment: null,
    basic_salary: null,
    gender: '0',
    birth_date: null,
    user_id: null,
    status: 'ACTIVE'
  }

  new_user_id: number = 0;
  Swal = 'sweetalert2'

  constructor(public utility: UtilitiesService, private api: ApiService, private modalService: NgbModal, private titleService: Title, private common: CommonService) {
    this.utility.show = true;
    this.token = localStorage.getItem('access_token');
  }

  open(content: any) {
    this.modalService.open(content);
  }

  edit(content: any, id: number) {
    this.modalService.open(content);

    let User = this.users.find(i => i.id === id);

    this.new_user_id = User.id;
    this.new_user = User;
  }

  changeP(content: any, id: number) {
    this.modalService.open(content);

    let User = this.users.find(i => i.id === id);

    this.user_password.id = User.id;
    this.user_password.email = User.email;
    this.user_password.password = User.password;
  }

  async ngOnInit(): Promise<void> {
    this.titleService.setTitle('Users Management');
    this.getUsers();
  }

  async getRoles() {
    const sub = this.api.get('users/roles/', this.token).subscribe(
      async data => {
        let objects: any = {
          roles: []
        }
        objects = data;

        this.roles = objects.roles;
        localStorage.setItem('roles', JSON.stringify(this.roles));
      },
      async error => { }
    );
    sub.add(() => { this.utility.loading = false; });
  }

  async getUsers() {
    this.utility.loading = true;
    const sub = this.api.get('users/', this.token).subscribe(
      async data => {

        let objects: any = {
          users: []
        }
        objects = data;

        this.users = objects.users;
        this.list_length = this.users.length;
      },
      async error => { }
    );
    sub.add(() => { this.getRoles(); });
  }

  async onDelete(id: number) {
    if (confirm("Delete this user?")) {
      this.api.delete('users/' + id, this.token).subscribe(
        async data => {
          this.getUsers();
          Swal.fire({
            title: 'Success!',
            text: 'User Deleted Successfuly!',
            icon: 'success',
            confirmButtonText: 'Cool'
          })
        },
        async error => {
          Swal.fire({
            title: 'Error!',
            text: 'Something went wrong!',
            icon: 'error',
            confirmButtonText: 'Ok'
          });
        }
      );
    }
  }

  async OnSubmit(content: any) {

    const emailPattern = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

    if (this.user.email == '' || this.user.password == '') {
      alert('يرجى ملء جميع الحقول');
    }
    else if (emailPattern.test(String(this.user.email).toLowerCase()) != true) {
      alert('يرجى إدخال البريد الإلكتروني الصحيح');
    }
    else {
      const body = {
        email: this.user.email,
        password: this.user.password,
        username: this.user.username,
        phone: this.user.phone,
        role_id: this.user.role_id
      }

      this.api.post("signup/", body, this.token).subscribe(
        async data => {
          let object: any = {}
          object = data;

          this.employee.user_id = object.id;
          let role = this.roles.find(i => i.id === this.user.role_id)?.name;

          if (role && role !== 'admin')
            this.modalService.open(content, { backdrop: 'static' });
          else
            this.getUsers();
        },
        async error => {
          Swal.fire({
            title: 'Error!',
            text: 'Something went wrong!',
            icon: 'error',
            confirmButtonText: 'Ok'
          })
        }
      );

      this.modalService.dismissAll();
    }
  }

  async OnUpdate(id: number) {

    const body = {
      email: this.new_user.email,
      phone: this.new_user.phone,
      role_id: this.new_user.role_id
    }

    this.api.update("users/" + id, body, this.token).subscribe(
      async data => {
        this.getUsers();
        Swal.fire({
          title: 'Success!',
          text: 'User Updated Successfuly!',
          icon: 'success',
          confirmButtonText: 'Cool'
        })
      },
      async error => {
        Swal.fire({
          title: 'Error!',
          text: 'Something went wrong!',
          icon: 'error',
          confirmButtonText: 'Ok'
        })
      }
    );

    this.modalService.dismissAll();
  }

  OnChangePassword(id: any) {
    const body = {
      password: this.user_password.password
    }

    this.api.update("users/password/" + id, body, this.token).subscribe(
      async data => {
        this.getUsers();
        Swal.fire({
          title: 'Success!',
          text: 'Password Changed Successfuly!',
          icon: 'success',
          confirmButtonText: 'Cool'
        })
      },
      async error => {
        Swal.fire({
          title: 'Error!',
          text: 'Something went wrong!',
          icon: 'error',
          confirmButtonText: 'Ok'
        })
      }
    );

    this.modalService.dismissAll();
  }

  isAdmin(username: string, role: string): boolean {
    if (username.toLowerCase() == 'admin' && role.toLowerCase() == 'admin') {
      return true;
    } else {
      return false;
    }
  }

  getRoleName(id_: number): string {
    let role: any = this.roles.find(i => i.id === id_);
    return role.name;
  }

  async onEnable(id: number) {
    if (confirm("Are sure you want to Enable the User?")) {
      this.api.update('users/enable/' + id, null, this.token).subscribe(
        async data => {
          this.getUsers();
          Swal.fire({
            title: 'Success!',
            text: 'User Enabled Successfuly!',
            icon: 'success',
            confirmButtonText: 'Cool'
          })
        },
        async error => {
          Swal.fire({
            title: 'Error!',
            text: 'Something went wrong!',
            icon: 'error',
            confirmButtonText: 'Ok'
          })
        }
      );
    }
  }

  async onDisable(id: number) {
    if (confirm("Are sure you want to Disable the User?")) {
      this.api.update('users/disable/' + id, null, this.token).subscribe(
        async data => {
          this.getUsers();
          Swal.fire({
            title: 'Success!',
            text: 'User Disabled Successfuly!',
            icon: 'success',
            confirmButtonText: 'Cool'
          })
        },
        async error => {
          Swal.fire({
            title: 'Error!',
            text: 'Something went wrong!',
            icon: 'error',
            confirmButtonText: 'Ok'
          })
        }
      );
    }
  }

  OnAddDetails() {
    const body = {
      name: this.employee.name,
      email: this.employee.email,
      phone: this.employee.phone,
      address: this.employee.address,
      country: this.employee.country,
      account_number: this.employee.account_number,
      bank_name: this.employee.bank_name,
      id_number: this.employee.id_number,
      id_expiry_date: this.employee.id_expiry_date,
      id_attachment: this.employee.id_attachment,
      basic_salary: this.employee.basic_salary,
      gender: this.employee.gender,
      birth_date: this.employee.birth_date,
      status: this.employee.status,
      user_id: this.employee.user_id,
    }

    const sub = this.api.post("employees/", body, this.token).subscribe(
      async data => {
        this.getUsers();
        Swal.fire({
          title: 'Success!',
          text: 'User Created Successfuly!',
          icon: 'success',
          confirmButtonText: 'Cool'
        })
      },
      async error => {
        Swal.fire({
          title: 'Error!',
          text: 'Something went wrong!',
          icon: 'error',
          confirmButtonText: 'Ok'
        })
      }
    );

    sub.add(() => { this.common.getDoctors(); });
    this.modalService.dismissAll();
  }
}
